import { createSlice } from "@reduxjs/toolkit";
import {
  createDealOfTheDay,
  getAllDeals,
  deleteDeal,
  toggleDealStatus,
} from "./ThunkAction";
import { iDealOfTheDayState, REDUCER_NAME } from "./Types";

const initialState: iDealOfTheDayState = {
  isLoading: false,
  dealList: [],
  errorMessage: null,
};

export const dealOfTheDaySlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetDealOfTheDayState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Create Deal
      .addCase(createDealOfTheDay.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(createDealOfTheDay.fulfilled, (state, action) => {
        if (action.payload?.data) {
          state.dealList = [action.payload.data, ...state.dealList];
        }
        state.isLoading = false;
        state.errorMessage = null;
      })
      .addCase(createDealOfTheDay.rejected, (state, action) => {
        //@ts-ignore
        state.errorMessage = action.payload?.message || "Failed to create deal";
        state.isLoading = false;
      })

      // Get All Deals
      .addCase(getAllDeals.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(getAllDeals.fulfilled, (state, action) => {
        state.dealList = action.payload?.data || [];
        state.isLoading = false;
        state.errorMessage = null;
      })
      .addCase(getAllDeals.rejected, (state, action) => {
        //@ts-ignore
        state.errorMessage = action.payload?.message || "Failed to fetch deals";
        state.isLoading = false;
        state.dealList = [];
      })

      // Delete Deal
      .addCase(deleteDeal.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(deleteDeal.fulfilled, (state, action) => {
        if (action.payload?.data) {
          state.dealList = state.dealList.filter(
            (deal) => deal.id !== action.payload?.data?.id
          );
        }
        state.isLoading = false;
      })
      .addCase(deleteDeal.rejected, (state, action) => {
        //@ts-ignore
        state.errorMessage = action.payload?.message || "Failed to delete deal";
        state.isLoading = false;
      })

      // Toggle Deal Status
      .addCase(toggleDealStatus.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(toggleDealStatus.fulfilled, (state, action) => {
        if (action.payload?.data) {
          const { id, status } = action.payload.data;
          const index = state.dealList.findIndex((deal) => deal.id === id);
          if (index !== -1) {
            state.dealList[index].status = status;
          }
        }
        state.isLoading = false;
      })
      .addCase(toggleDealStatus.rejected, (state, action) => {
        //@ts-ignore
        state.errorMessage = action.payload?.message || "Failed to toggle deal status";
        state.isLoading = false;
      });
  },
});

export const { resetDealOfTheDayState } = dealOfTheDaySlice.actions;
export default dealOfTheDaySlice.reducer;